import { Component } from '@angular/core';

@Component({
  selector: 'ark-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'desktop';
}
